export const menuItemMedia = {
    root: 'table w-full txt-c1 hover:text-inherit hover:underline pl-4 mb-4',
    left: 'table-cell align-top w-16',
    right: 'table-cell align-top px-2',
    thumbnailWrap: 'img-ratio-4x3 block border border-grey-light',
    thumbnail: 'lazyload fade-up block',
    title: 'leading-normal my-0',
    detail: 'leading-tight my-0'
};

export const dropMenu = {
    root: 'nav-drop-menu hidden absolute z-10 shadow-md font-normal whitespace-normal -ml-4',
    header: 'ml-8 mb-6 mt-8 w-full',
    heading: 'mb-4 text-lg txt-c1',
    figure: 'hidden absolute z-10 border-box m-0 w-64 pin-t pin-r translate-x min-h-full bg-white',
    primaryMenu: 'nav-drop-menu--primary leading-normal pin-l',
    megaMenu: 'nav-drop-menu--mega pin-l whitespace-normal flex-wrap',
    accountMenu: 'nav-drop-menu--account -ml-4'
};

export const dropMenuNav = {
    root: 'nav-menu border-box min-h-full mt-8',
    list: 'nav-menu-list list-reset mb-3 txt-c1 p-0 m-0 border-r border-grey-light',
    item: 'nav-item--with-indicator relative txt-c1 hover:text-inherit flex items-center pl-8 py-1 border-l-8 border-solid border-white'
};